module.exports = __webpack_public_path__ + "static/eps-web-header-13b61846ebaea548c8f03602320f2638.webp";